import EsetleirasTableService from 'app/admin/esetleiras/service/EsetleirasTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'esetleirasTable',
	text: 'Esetleírás',
	textKey: 'caseHistory',
	service: EsetleirasTableService,
	icon: 'person',
	editFormState: item => `/esetleiras/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csorszam',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'csorszam',
			text: 'Sorszám',
			textKey: 'csorszam',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
        /*{
			key: 'nev',
			text: 'Név',
			textKey: 'nev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},*/
		{
			key: 'feladatCsoport',
			text: 'Feladatcsoport',
			textKey: 'feladatCsoport',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function EsetleirasTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('esetleirasTable', reducer('esetleirasTable'))(EsetleirasTable);
